import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Grid } from '@shared/ui';

export function GridShowcase() {
  const { t } = useTranslation();
  const gridTwoCells = ['alpha', 'beta', 'gamma', 'delta'];
  const gridThreeCells = ['one', 'two', 'three', 'four', 'five', 'six'];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.layout.grid.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.layout.grid.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Grid cols={2} gap="sm">
          {gridTwoCells.map((cell) => (
            <div key={`grid-2-${cell}`} className="h-12 rounded-md bg-muted/60" />
          ))}
        </Grid>
        <Grid cols={3} gap="sm">
          {gridThreeCells.map((cell) => (
            <div key={`grid-3-${cell}`} className="h-10 rounded-md bg-muted/60" />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
